<template>
    <div>
        <div class="w">
            <div class="oheader">
                <a href="/" title="夜樱情趣" class="left">
                    <img src="../../assets/image/logo.png">
                </a>
                <!-- <a href="javascript:;" onclick="jieshou()" class="xhb right"><em class="f pr5 f14"></em>联系客服</a> -->
                <a href="/" class="xhb right mr10">继续购物</a>
                <div class="clear"></div>
            </div>
        </div>
        <div class="w" id="content">
            <div style="text-align:center;font-size:26px;font-weight:bold;color:#f00180;line-height:40px;">支付成功！</div>
            <div style="text-align:center;font-size:26px;font-weight:bold;color:#f00180;line-height:40px;">实付款：{{$fnc.toFixedZ(info.money,2)}}</div>
            <div style="text-align:center;">
                <!-- <div alt="" style="float:left">
                    <img src="../../assets/image/order/success.png">
                </div> -->
                <div>
                    <p style="line-height:36px;font-size:20px;">您的订单编号为：</p>
                    <p style="line-height:36px;font-size:20px;">{{info.oid}}</p>
                    <p style="line-height:36px;font-size:20px;">支付时间：{{$fnc.getTimeFormat(info.pay_time)}}</p>
                </div>
            </div>
            <div style="text-align:center;font-size:20px;font-weight:bold;margin-top:50px;margin-bottom:50px;">
                <span style="padding:10px 20px;background:#f00180;margin-right:20px;"><a href="/" style="color:#ffffff;">返回首页</a></span>
                <span style="padding:10px 20px;background:#f00180;color:#ffffff;"><a href="/user_order" style="color:#ffffff;">查看订单</a></span>
            </div>
            <hot-product></hot-product>
        </div>
        
        <p class="bf_footer">
            <a href="/" class="c9" target="_blank">首页</a>
            <em class="vline">|</em>
            <a href="javascript:;" class="c9"  v-for="(items,index) in category" :key="items.id"  @click="catesearch(items.title,index)">
                {{items.title}}
                <em class="vline">|</em>
            </a>
        </p>
        <p class="fuwu">下单代表同意夜樱情趣 <a href="/help/fuwuxieyi" class="U" target="_blank">服务协议</a><a href="/help/falvshengming" class="U" target="_blank">法律声明</a><a href="/help/yinsibaohu" class="U" target="_blank">隐私政策权</a></p>
    </div>
</template>

<script>
import HotProduct from '../common/hot-product.vue'
export default {
    components:{
        "hot-product" : HotProduct
    },
    data(){
        return {
            category:[],
            info:"",
        }
    },
    created(){
        this.getShopCate();
        this.getOrderInfo();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
        getOrderInfo(){
            var params = {};
            params.id = this.$route.query.id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getOrder.IsSuccessOrder(params).then(res => {
                if (res.code == 200) {
                    //已支付
                    this.info = res.result;
                    var oid = res.result.oid;
                    this.oid_arr = []
                    if (oid.indexOf(',') >= 0) {
                        this.oid_arr = oid.split(',')
                    } else {
                        this.oid_arr.push(res.result.oid)
                    }
                    this.coupon_list = res.result.coupon || [];
                    if (res.result.is_pay == 1) {
                        var params = {}
                        params.con = '支付后';
                        params.oid = this.$route.query.id;
                        params.uid = JSON.parse(window.localStorage.getItem("user")).id;
                        this.$api.getOrder.is_turntable(params).then(res => {
                            if (res.code == 200 && res.result != false) {
                                this.turn_show = true;
                            } else {
                                JSON.stringify(this.coupon_list) != '[]' ? this.coupon_show = true : ""
                            }
                        })
                    }
                    if (res.result.is_pay == 0) {
                        setTimeout(() => {
                        this.getOrderInfo();
                        }, 3000)
                    }
                    //消费红包
                    if (res.result.is_packet_xf == '1') {
                        this.$api.getShop.getCoupon({
                        oid: oid
                        }).then(res => {
                            if (res.code == 200) {
                                this.consumption = res.result;
                                if (!this.is_turn) {
                                    if (JSON.stringify(this.consumption.red_data) != '{}' && this.consumption.red_data && this.consumption.red_data != undefined) {
                                        this.consumption_show = true;
                                        this.share(); //分享
                                    }
                                }
                            }
                        })
                    }
                }
            });
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
@import url('../../assets/css/car.css');
</style>


// WEBPACK FOOTER //
// src/components/car/success.vue